// extracted by mini-css-extract-plugin
export default {"redditLink":"reddit-embed_redditLink__cSZri"};